import React, { useEffect, useState } from "react";
import { Button } from "sr/helpers";
import { useAuth } from "../module/auth";

export const AppUseNotification = () => {
  const { userType } = useAuth();

  const [show, setShow] = useState(true);
  const [showeffect, setShowEffect] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const handleModelClose = () => {
    setTimeout(() => {
      setShowEffect(false);
    }, 200);

    setTimeout(() => {
      setShow(false);
    }, 600);
  };

  // Don't render at all on tablet/desktop
  if (!isMobile) {
    return null;
  }

  return (
    <>
      <div
        className={`w-full transitioncss ${
          showeffect ? "modeleffect" : "popup"
        } ${
          show ? "block" : "hidden"
        } xl:hidden lg:hidden bg-[#FAF9F8] fixed px-4 py-2 top-0 z-50`}
      >
        <div className="flex items-center justify-between">
          <div
            onClick={handleModelClose}
            className="w-10 cursor-pointer h-10 pr-3 flex justify-center items-center"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>

          <div className="w-2/3">
            <p className="font-bold text-lg">Get the Jani Jobs App</p>
            <p>Download & Use Jani Jobs App</p>
          </div>

          <div className="w-1/3 flex justify-end">
            <Button
              childCSS="py-1"
              className="bg-[#ff39b3] p-3 text-white"
              text="Download"
            />
          </div>
        </div>
      </div>

      {show && userType !== "individual" && userType !== "company" && (
        <div className="h-[4.2rem] lg:hidden xl:hidden"></div>
      )}
    </>
  );
};
